module.exports = "<div>\r\n\r\n  <router-link to=\"/\" class=\"wc-button\">Home</router-link>\r\n  <router-link to=\"/form\" class=\"wc-button\">Form</router-link>\r\n\r\n  </br>\r\n  </br>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/router-menu.html
// module id = 434
// module chunks = 0